import PointOfInterest from './PointOfInterest';

/**
 * Class which defines a lunr client
 */
export default class LunrClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  /**
   * sending a search request to lunr
   * @param {query to search} query
   * @param {categories to search} categories
   * @param {geom to search} searchGeom
   * @return object with properties 'response' as the docs of the lunr response
   *         and 'facets' which holds the facets of the lunr response
   */
  async search(query, categories, searchResultPage, lat, lon, distance) {
    const call = await fetch(
      this.lunrSearchUrl(query, categories, searchResultPage, lat, lon, distance),
    );
    const json = await call.json();

    const poiArray = [];
    // Building PointOfInterests
    json.docs.forEach((doc) => {
      /* eslint-enable */
      poiArray.push(new PointOfInterest(
        doc.id,
        doc.label,
        doc.sublabel,
        doc.category,
        JSON.parse(doc.geom),
        JSON.parse(doc.metaData),
        doc.centerCoordinate,
      ));
    });

    const facetCounts = [];

    // Bulding facetcount
    Object.keys(json.facets).forEach((key) => {
      facetCounts[`${key}`] = Number(json.facets[key]);
    });
    return { response: poiArray, facets: facetCounts, numFound: json.totalHits };
  }

  /**
   * Building a lunr query
   * @param {query} query
   * @param {categories} categories
   * @param {spatial data} spatial
   * @param {start} start
   */
  lunrSearchUrl(query, categories, searchResultPage, lat, lon, distance) {
    const serverUrl = this.baseUrl;
    const start = (searchResultPage * 10) - 10;
    // removing stuff from query
    let searchQuery;
    let searchParam;

    if (query !== null && query !== '') {
      searchQuery = query.replace(/\//g, '/');
      searchQuery = encodeURIComponent(searchQuery);
      searchParam = this.buildQueryParam(searchQuery);
    }

    let currentLunrUrl = serverUrl.concat('search?');
    if (searchParam !== undefined) {
      currentLunrUrl = currentLunrUrl.concat(searchParam);
    }
    if (lat !== undefined && lon !== undefined) {
      currentLunrUrl = currentLunrUrl.concat(`&${this.buildSpatialParam(lat, lon)}`);
      if (distance !== undefined) {
        currentLunrUrl = currentLunrUrl.concat(`&d=${distance}`);
      }
    }

    currentLunrUrl = currentLunrUrl.concat(`&start=${start}`);
    currentLunrUrl = currentLunrUrl.concat(this.buildFieldSearch(categories));

    return currentLunrUrl;
  }

  /**
   * helper method to build the query param
   * @param {*} searchQuery
   */
  buildQueryParam = (searchQuery) => {
    const queryUrlParam = 'q=';
    const queryParam = queryUrlParam.concat(searchQuery);
    return queryParam;
  }

  /**
   * helper method to build the field search param
   * @param {*} categories
   */
  buildFieldSearch = (categories) => {
    let fieldQueries = '';
    categories.forEach((cat) => {
      fieldQueries = fieldQueries.concat(`&f=category:${cat}`);
    });
    return fieldQueries;
  }

  /**
   * helper method to build the spatial param
   * @param {*} lat
   * @param {*} lon
   */
  buildSpatialParam = (lat, lon) => {
    const spatialTemplate = `lat=${lat}&lon=${lon}`;
    return spatialTemplate;
  }
}
